import { Component} from '@angular/core';
import * as _str from 'underscore.string';

@Component({
    selector: 'task-manager',
    template: require('./taskManager.component.html')
})
export class TaskManagerComponent {
   public projectId:any;

    constructor(){
    
     
  }

  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/taskManager-ang7/taskManager.component.ts